var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79688 1.05078C4.59375 1.21484 3.44531 1.70703 2.46094 2.52734L4.56641 4.63281C5.33203 3.64844 5.74219 2.41797 5.79688 1.05078ZM6.78125 6.82031L11.0742 2.52734C9.92578 1.57031 8.53125 1.05078 7.10938 0.96875C7.08203 2.71875 6.50781 4.33203 5.49609 5.5625L6.78125 6.82031ZM1.53125 3.45703C0.710938 4.44141 0.21875 5.58984 0.0546875 6.79297C1.42188 6.73828 2.65234 6.32812 3.63672 5.5625L1.53125 3.45703ZM8.96875 9.03516C10.1992 8.02344 11.8125 7.44922 13.5625 7.42188C13.4805 6 12.9609 4.60547 12.0039 3.45703L7.71094 7.75L8.96875 9.03516ZM6.78125 8.67969L2.46094 13C3.60938 13.957 5.00391 14.4766 6.42578 14.5312C6.45312 12.7812 7.02734 11.1953 8.03906 9.96484L6.78125 8.67969ZM12.0039 12.0703C12.8242 11.0859 13.3164 9.9375 13.4805 8.73438C12.1133 8.78906 10.8828 9.19922 9.89844 9.96484L12.0039 12.0703ZM4.56641 6.49219C3.33594 7.50391 1.72266 8.07812 0 8.10547C0.0546875 9.52734 0.574219 10.9219 1.53125 12.0703L5.85156 7.75L4.56641 6.49219ZM7.73828 14.4766C8.94141 14.3125 10.0898 13.8203 11.0742 13L8.96875 10.8945C8.20312 11.8789 7.79297 13.1094 7.73828 14.4766Z",
    fill: "#A21D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.6a7dbe1adc66fcf72c976d1aafdca445.svg";
export { ForwardRef as ReactComponent };